import { useState, useEffect } from 'react';
import Text from 'components/typography/Text';
import moment from 'moment';

export default function PaymentSummaryItem({ label, amount, balanceDueDate = '' }) {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const onWindowResize = () => {
    setIsMobile(window.innerWidth < 768);
  };

  useEffect(() => {
    window.addEventListener('resize', onWindowResize);
    return () => window.removeEventListener('resize', onWindowResize);
  }, []);

  const dateFormat = isMobile ? 'DD MMM yyyy' : 'DD MMMM yyyy';

  return (
    <div className="flex justify-between py-3 border-b">
      <Text className="mr-4">{label}</Text>
      <div className="flex items-center">
        {balanceDueDate && (
          <div className={`${isMobile && "text-xs"} bg-red-500 text-white px-4 py-1 rounded-full mr-4`}>
            Due by: {moment(balanceDueDate).format(dateFormat)}
          </div>
        )}
        <Text>{amount}</Text>
      </div>
    </div>
  );
}
